<template>
    <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
      <div class="container-fluid" v-if="$store.getters.marchand">
        <v-toolbar dense style="margin-bottom: 25px;padding: 0" height="90">
          <v-toolbar-title></v-toolbar-title>
          <div class="row">
            <div class="col-12 col-lg-4 col-md-4 p-0">
              <v-menu
                  ref="menu"
                  v-model="filter"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field style="margin-bottom: -3%"
                                v-model="date"
                                prepend-inner-icon="mdi-filter-variant"
                                v-bind="attrs" readonly solo
                                v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="offset-lg-4 offset-md-4 col-12 col-lg-4 col-md-4 p-0">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                            hide-details></v-text-field>
            </div>
          </div>
        </v-toolbar>
        <v-card elevation="7">
          <v-tabs v-model="transactions_tabs">
            <v-tab @click="filterTransaction('all')">Tous</v-tab>
            <v-tab @click="filterTransaction('waitting')">En cours</v-tab>
            <v-tab @click="filterTransaction('finish')">Terminer</v-tab>
            <v-tab @click="filterTransaction('archive')">Archiver</v-tab>
          </v-tabs>
         
         <div>
             <v-data-table
                  :headers="headers"
                  :items="transactions"
                  :items-per-page="15"
                  class="elevation-1"
                  :loading="loadingTransactions"
                  no-data-text="Aucune transaction trouvée"
                  :search="search"
              >
                <template v-slot:top>
                    <v-row style="background: #f8f8f8;">
                      <v-toolbar
                          flat
                      >
                        <v-toolbar-title >Mes transactions</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            color="primary"
                            dark
                            class="mb-2 mr-2"
                            @click="dialogTransaction = true"
                        >
                          Créer une transaction
                        </v-btn>
                      </v-toolbar>
                    </v-row>
                  </template>
  
                <template v-slot:item._amount="{item}">
                  {{ formatAmount(item._payments.map(payment => payment._amount).reduce((a, b) => a + b, 0)) }} F CFA
                </template>
                <template v-slot:item._createdAt="{item}">
                  {{ getDate(item._createdAt) }}
                </template>
                <template v-slot:item._name="{item}">
                  {{ item._student._firstName }} {{ item._student._lastName }}
                </template>
                <template v-slot:item._type_programmation="">
                <span class="programm_text text-uppercase">  tranche</span>
                </template>
                <template v-slot:item._status="{item}">
                  <span :class="item._archive ? 'badge badge-danger text-uppercase' : (item._status ? 'badge badge-success text-uppercase' : 'badge badge-warning text-uppercase')">  
                    {{ item._archive ? 'archiver' :  (item._status ? 'Terminer' : 'en cours') }}
                  </span>
                </template>
                <template v-slot:item.action="{item}">
                  <div style="text-align:  right">
                    <v-menu
                        key="text"
                        rounded="b-xl">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                            class="black--text "
                            v-bind="attrs"
                            v-on="on">mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list v-for="(action_item, index) in transaction_actions_items" :key="index">
                       <!--  <v-list-item v-if="((!item.programmation || item.programmation===null ) && action_item.title!=='Programmer la transaction')"> -->
                        <v-list-item  link 
                            @click="transaactionItemAction(item,index)" v-if="action_item.title==='Programmer le paiement' && (!item._programmation || item._programmation===null ) ">
                         <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      <v-list-item  link 
                            @click="transaactionItemAction(item,index)" v-else-if="action_item.title!=='Programmer le paiement' && action_item.title!=='Terminer' && action_item.title!=='Archiver' && !action_item._status">
                         <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      <v-list-item  link 
                            @click="transaactionItemAction(item,index)" v-if="action_item.title==='Terminer' &&  (!item._status && !item._archive)">
                         <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      <v-list-item  link 
                            @click="transaactionItemAction(item,index)" v-if="action_item.title==='Archiver' && !item._archive">
                         <v-list-item-icon>
                            <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-data-table>
             <div class="text-right" style="background : #f8f8f8">
                  <v-pagination
                  elevation="0"
                  v-model="page"
                  :length="total_pages"
                  :total-visible="7"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="getMarchandClientTransaction"
                  ></v-pagination>
                <!-- product pagination -->
          </div>
         </div>
  
          <v-dialog v-model="showPaiementDialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span >Programmation de paiement ({{ current_montant_total }} F CFA)</span>
              </v-card-title>
  
              <v-card-text>
               <fieldset v-show="step===1">
                 <v-row>
                   <div class="col-12 mb-0 pb-0">
                      <label for="">Veuillez choisir un type de programmation</label> <br>
                      <v-autocomplete solo label="Choisir un type de programmation" :items="type_programmation"
                                      v-model="selected_type_programmation" item-text="text" item-value="code">
                      </v-autocomplete>
                  </div>
                </v-row>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-radio-group v-model="selected_canal" label="Par quel Canal souhaitez-vous notifier vos clients" row>
                      <v-radio label="SMS" value="sms"/>
                      <v-radio label="WHATSAPP" value="whatsapp"/>
                      <v-radio label="EMAIL" value="email"/>
                    </v-radio-group>
                  </v-col>
                  <div class="col-12 mt-0 mb-0 pt-0 pb-0" v-if="selected_canal">
                      <v-alert  elevation="0" class="mb-0" type="warning">
                        Assurez-Vous d'avoir ajouter au préalable {{ text_selected_canal }} des clients liés a cette transaction.
                      </v-alert>
                  </div>
                </v-row>
                <v-row>
                  <div class="col-12">
                    <label>Personnalisé le texte de notification qui sera envoyer au client.</label>
                    <label><code> <strong>#amount</strong> = montant de la transaction </code> &nbsp;<code> <strong>#last_name</strong> = nom du client  </code>
                     &nbsp;<code> <strong>#first_name</strong> = prenom du client </code> &nbsp;<code> <strong>#enterprise_name</strong> = nom de votre entreprise  </code>
                     &nbsp;<code> <strong>#my_email</strong> = votre addresse email  </code>
                    </label>
                    <label for="">Utilisez les codes ci-dessous pour écrire un message personnalisé.</label>
                  <v-textarea solo v-model="text_notification" label="Saisir le texte"
                               rows="2">
                  </v-textarea>
                  </div>
                </v-row>
               </fieldset>
                <fieldset v-show="step===2">
                <v-card v-if="selected_type_programmation !== 'immediat'" class="mt-2  px-3" elevation="0" outlined>
                  <h5 class="mt-3">{{ title_action_type_programmation }}</h5>
                  <v-row v-if="selected_type_programmation === 'tranche'" align="center" justify="center">
                    <v-col>
                      <v-text-field solo v-model="currentTrancheProgramm.amount" label="Montant à payer"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-menu
                          v-model="pickdateprogram"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field solo
                              v-model="currentTrancheProgramm.date"
                              label="Choisir la date de paiement"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="currentTrancheProgramm.date"
                            @input="pickdateprogram = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="3">
                      <v-btn small dark @click="addTranche">
                        + ajouter
                      </v-btn>
                    </v-col>
                  </v-row>
  
                  <v-row v-if="selected_type_programmation === 'periodique'" align="center" justify="center">
                    <v-col>
                      <label>Veuillez définir la périodicité</label>
                      <v-autocomplete solo :items="periodicites" item-text="text" item-value="code"
                                      v-model="selected_periodicite">
                      </v-autocomplete>
                    </v-col>
                    
                  </v-row>
                  <v-row v-if="selected_type_programmation === 'periodique'" align="center" justify="center">
                    <v-col >
                      <v-row >
                        <v-col cols="12" class="mb-0 pt-0 pb-0 mt-0">
                      <label>Choisir la date du premier paiement</label>
                      </v-col>
                      <v-col cols="12" class="mb-0 pt-0 pb-0 mt-0">
                      <v-menu
                          v-model="pickdateprogram"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="currentPeriodiqueProgramm.date"
                              label="Choisir une date"
                              prepend-icon="mdi-calendar"
                              readonly solo
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="currentPeriodiqueProgramm.date"
                            @input="pickdateprogram = false"
                        ></v-date-picker>
                      </v-menu>
                      </v-col>
                      </v-row>
                    </v-col> 
                     <v-col>
                      <v-row >
                        <v-col cols="12" class="mb-0 pt-0 pb-0 mt-0">
                      <label>Choisir la date de fin de la périodicité</label>
                      </v-col>
                      <v-col cols="12" class="mb-0 pt-0 pb-0 mt-0">
                      <v-menu
                          v-model="pickdateprogramEnd"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field solo
                              v-model="currentPeriodiqueProgrammEnd.date"
                              label="Choisir une date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="currentPeriodiqueProgrammEnd.date"
                            @input="pickdateprogramEnd = false"
                        ></v-date-picker>
                      </v-menu>
                      </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
  
                  <v-row v-if="selected_type_programmation === 'ulterieur'" align="center" justify="center">
                    <v-col>
                      <v-menu
                          v-model="pickdateprogram"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field solo
                              v-model="currentUlterieurProgramm.date"
                              label="CHoisir la date de paiement"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="currentUlterieurProgramm.date"
                            @input="pickdateprogram = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card v-if="selected_type_programmation === 'tranche'" class="mt-4 px-3" elevation="0" outlined>
                  <h5 class="mt-3">Tranches definies</h5>
                  <v-data-table :headers="headersTranches" :items="selected_tranches"
                                no-data-text="Vous n'avez pas encore ajouté de tranche">
                    <template v-slot:item._actions="{ item }">
                      <v-icon @click="selected_tranches.splice(selected_tranches.indexOf(item), 1)" color="red">
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
                </fieldset>
              </v-card-text>
              <v-card-actions>
                <div class="col-12 text-right">
                  <v-btn color="dark" class="mr-2 mb-0" @click="closeProgrammTransaction()">Annuler</v-btn>
                  <v-btn color="warning" class="mr-2 mb-0" v-if="step > 1" @click="step--">Précédent</v-btn>
                  <v-btn class=" mb-0" :loading="loadindScheduleTransaction" @click="selected_type_programmation !== 'immediat' ? (step===1 ? step++ : saveProgramTransaction()) : saveProgramTransaction()">{{ selected_type_programmation !== 'immediat' ? (step===1 ? 'Continuer' :  'Enregistrer') : 'Enregistrer' }}</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
     <v-dialog
          v-model="dialogTransaction"
          persistent
          scrollable
          max-width="600px"
      >
        <v-card>
         
          <v-card-text class="mt-5">
            <div v-if="categories && clients && products">
            <h5 class="mb-4">
              Générer une transaction
            </h5>
            <label>Générer une transaction pour:</label>
            <v-radio-group v-model="forCategoryClient" row class="mt-0 pt-0">
              <v-radio label=" Une Catégorie de client" :value="true">
              </v-radio>
              <v-radio label=" Un ou plusieur Clients" :value="false">
              </v-radio>
            </v-radio-group>
         
            <v-row>
              <v-col col="12">
              <label> Sélectionner une option</label> <br>
              <v-select solo multiple v-if="forCategoryClient" :items="categories" item-text="_name" item-value="_id"
                        label="Sélectionner une catégorie de client" v-model="selected_category_client"></v-select>
              <v-select solo multiple v-if="!forCategoryClient" :items="clients" item-text="_first_name" item-value="_id"
                        label="Sélectionner un ou des clients" v-model="selected_client_transaction"></v-select>
              </v-col>
            </v-row>
  
               <v-row>
                 <v-col col="12">
                    <label> Libellé des transactions</label> <br>
                    <v-text-field solo v-model="transaction_name" label="Libellé de la transaction"></v-text-field>
                 </v-col>
            </v-row>
  
            <v-row>
                    <div class="col-12 col-lg-8">
                        <v-checkbox
                        class="mt-0 pt-0 mb-0 pb-0"
                          v-model="fees_support"
                          label="Supporter les frais de transaction"
                        ></v-checkbox>
                    </div>
                </v-row>
  
            <v-card
                outlined
                class="pt-0 pb-0"
            >
              <v-card-text class="pb-0">
                <v-row>
                  <h5 class="col-12">Choisissez les produits à associer à cette transaction.</h5>
                  <v-col cols="12" sm="7"  md="7" class="pb-0 mb-0">
                  <label> Choisir un produit</label>
                    <v-select solo
                        label="Choisir un produit"
                        :items="products"
                        item-text="_name"
                        item-value="_id"
                        v-model="currentProduct"
                        return-object
                        required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" class="pb-0 mb-0">
                  <label> Quantité</label>
                    <v-text-field solo
                        label="Quantité"
                        v-model="currentQuantity"
                        type="number"
                        required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" class="mt-0 pt-lg-5 mt-lg-5">
                    <v-btn  color="secondary" @click="addProductToTransaction"> + ajouter</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-container>
              <v-row v-if="transaction_products.length > 0">
                <v-data-table style="width: 100%;" :items="transaction_products" :headers="transaction_products_header">
                  <template v-slot:item.actions="{ item }">
                    <v-btn text @click="transaction_products.splice(transaction_products.indexOf(item), 1)">
                      <v-icon color="red">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-row>
              <v-row v-if="transaction_products.length === 0">
                <v-alert
                type="warning"
                    elevation="0"
                >
                Vous devez associer des produits à cette transaction pour continuer ...
                </v-alert>
              </v-row>
            </v-container>
            </div>
            <div v-else>
              <div >
                 <h3> Certaines configuration préalable sont nécessaires pour ajouter une transaction</h3>
                 <div class="alert alert-warning" v-if="!categories || categories.length <=0"> Ajouter une catégorie de client avant de continuer <router-link to="/customers" > accéder à la page</router-link> </div>
                 <div class="alert alert-warning" v-if="!clients || clients.length <=0"> Ajouter un client avant de continuer <router-link to="/customers"> accéder à la page</router-link> </div>
                 <div class="alert alert-warning" v-if="!products || products.length <=0"> Ajouter un produit  avant de continuer <router-link to="/products"> accéder à la page</router-link> </div>
                  <div>
                    <v-btn color="dark" small @click="resetTransaction()" > Fermer </v-btn>
                  </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions v-if="categories && clients && products">
            <v-spacer></v-spacer>
            <v-btn
                color="dark"
                @click="resetTransaction()"
            >
              annuler
            </v-btn>
            <v-btn
             :disabled="!transaction_products 
             || transaction_products.length <= 0 
             || !transaction_name 
             || transaction_name==='' 
             || ( forCategoryClient && !selected_category_client
             && selected_category_client.length <=0)
             || (!forCategoryClient && !selected_client_transaction)
             "
                color="primary darken-1"
                @click="saveTransaction"
                :loading="transactionInProgress"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
          <v-dialog v-model="linkedClientsDialog" @click:outside="linkedClientsDialog = false" max-width="800px">
            <v-card>
              <v-card-title><h5>Clients liés à la transaction </h5></v-card-title>
              <v-card-text>
                <v-data-table :items="linkedClients" :headers="linkedClientsHeaders">
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-btn class="dark" @click="linkedClientsDialog = false">Fermer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </div>
    </div>
  </template>
  
  <script>
  import {client} from "../../store/services/client";
  import helpers from "../../mixins/helpers";
  
  export default {
    name: "MarchandScheduledTransactions",
    mixins: [helpers(this)],
    data() {
      return {
        step: 1,
         total_pages: 0,
        page: 1,
        dialogTransaction: false,
        categories:undefined,
        produits: [],
        fees_support:false,
        products: undefined,
        clients: undefined,
        transaction_name:'',
        currentProduct: null,
        currentQuantity: 1,
        allTransaction: [],
        selected_canal: 'email',
        selected_tranches: [],
        text_notification: "",
        selected_client_transaction: [],
        selected_category_client: [],
        transactionInProgress: false,
        transaction_products:  [],
        requiredRules: [
          v => !!v || 'Ce champ est recquis',
        ],
        forCategoryClient: false,
        transaction_products_header: [
          {text: 'Produit', value: 'product._name'},
          {text: 'Quantité', value: 'settings._quantity'},
          {text: 'Actions', value: 'actions'},
        ],
        periodicites: [
          {text: 'Journalier', code: 'journalier'},
          {text: 'Hebdomadaire', code: 'hebdomadaire'},
          {text: 'Mensuel', code: 'mensuel'},
          {text: 'Trimestriel', code: 'trimestriel'},
          {text: 'Semestriel', code: 'semestriel'},
          {text: 'Annuel', code: 'annuel'},
        ],
        linkedClientsHeaders: [
          {text: 'Nom', value: '_last_name'},
          {text: 'Prénom', value: '_first_name'},
          {text: 'Catégorie de client', value: '_category'},
          {text: 'Email', value: '_email'},
          {text: 'Téléphone', value: '_phone'},
          {text: 'Adresse', value: '_address'},
          {text: '', value: 'actions', sortable: false},
        ],
        loadindScheduleTransaction: false,
        currentUlterieurProgramm: {
          date: null,
        },
        currentPeriodiqueProgramm: {
          date: null
        },
        currentPeriodiqueProgrammEnd: {
          date: null
        },
        currentTrancheProgramm: {
          date: null,
          amount: 0,
        },
        headersTranches: [
          {text: 'Montant', value: 'amount'},
          {text: 'Date', value: 'date'},
          {text: 'Actions', value: '_actions'}
        ],
        programmes_transaction: [],
        current_montant_total: 0,
        transaction_actions_items: [
          // {avatar: 'mdi-calendar-clock', title: 'Programmer le paiement'},
           {avatar: 'mdi-eye', title: 'Détails transaction'},
          // {avatar: 'mdi-checkbox-multiple-outline', title: 'Terminer'},
          // {avatar: 'mdi-archive-cog-outline', title: 'Archiver'},
          // {avatar: 'mdi-account-multiple', title: 'Clients'},
        ],
        search: "",
        selected_type_programmation: 'immediat',
        type_programmation: [
          {
            text: 'Paiement immédiat',
            code: 'immediat',
          },
          {
            text: 'Paiement par tranche',
            code: 'tranche'
          },
          {
            text: 'Paiement périodique',
            code: 'periodique'
          },
          {
            text: 'Paiement à une date ultérieure',
            code: 'ulterieur'
          }
        ],
        trx: null,
        transactions_tabs: null,
        customer_transactions: [],
        loadingTransactions: false,
        pickdateprogram: false,
        pickdateprogramEnd: false,
        showPaiementDialog: false,
        transactions: [],
        linkedClients: [],
        linkedClientsDialog: false,
        filter: '',
        selected_periodicite: null,
        date: new Date().toISOString().substr(0, 10),
      }
    },
    methods: {
      getAmountFromChoosenProduct(products) {
        let amount = 0
        products.forEach(row => {
          amount += row.product._price * row._quantity
        })
  
        return amount
      },
      resetTransaction(){
        this.transaction_name= "";
        this.forCategoryClient=false;
        this.selected_client_transaction=[];
        this.transaction_products=[];
        this.selected_category_client=[];
        this.currentProduct= null,
        this.currentQuantity= 1,
        this.allTransaction= [],
        this.dialogTransaction = false
        this.fees_support = false
      },
      async saveTransaction() {
        this.transactionInProgress = true
        const data = {
          transaction_name: this.transaction_name,
          forCategoryClient: this.forCategoryClient,
          _clients: this.selected_client_transaction,
          _products: this.transaction_products,
          _categories: this.selected_category_client,
          _fees_support: this.fees_support,
          _amount: 0
        }
        //const uid = this.makeid(8) // uid generated
        const amount = this.getAmountFromChoosenProduct(data._products)
        data._amount = amount
        const initdata = {
          public_key: JSON.parse(sessionStorage.getItem('keys'))._public_key,
          amount: amount,
          sandbox: false,
          currency: 'xof',
          company: {},
          name: 'oualid',
          template: 'default+',
          color: 'green',
          logo_url: 'https://sungrocery.sunmarket.biz/images/boutiques/logos/1635548675-logo.jpg'
        };
  
        // save the transaction in backend
        const response = await client({
          method: 'post',
          url: '/marchand/client_transaction',
          data: {
            data: data,
            initdata: initdata
          }
        })
            .then(res => res.data)
            .catch(() => {
              return {
                error: true
              }
            })
  
  
        if (!response.error) {
          this.getMarchandClientTransaction()
          this.resetTransaction()
        }
        this.transactionInProgress = false
        this.toast(response.type, response.message)
      },
       async getMarchanProducts() {
        const response = await client({
          method: 'get',
          url: '/marchand/product/get'
        })
            .then(resp => resp.data)
            .catch(error => {
              console.log(error)
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.products = response.products
        }
      },
      makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() *
              charactersLength));
        }
        return result;
      },
      
      addProductToTransaction() {
        if (!this.currentProduct)
          return
        const exist = this.transaction_products.filter(x => x.product._id === this.currentProduct._id)
  
        if (exist && exist.length > 0) {
          const index = this.transaction_products.indexOf(exist[0])
  
          this.transaction_products[index].settings._quantity += this.currentQuantity
        } else {
          this.transaction_products.push({
            product: this.currentProduct,
            _product_id: this.currentProduct._id,
            _quantity: this.currentQuantity,
            settings: {
              _quantity: this.currentQuantity,
            }
          })
        }
      },
      filterTransaction(val){
        switch(val){
          case 'all' :
              this.transactions = this.allTransaction;
            break; 
         case 'waitting' :
             this.transactions = this.allTransaction.filter(r=>!r._status && !r._archive);
            break; 
         case 'finish' :
             this.transactions = this.allTransaction.filter(r=>r._status && !r._archive);
            break; 
         case 'archive' :
            this.transactions = this.allTransaction.filter(r=>r._archive);
           break;
         default :
              this.transactions = this.allTransaction.filter(r=>!r._archive);
            break; 
        }
      },
      async resetProgrammTransaction (){
          this.selected_type_programmation='immediat';
          this.selected_tranches= [];
          this.selected_canal= null,
          this.selected_periodicite= null;
          this.currentUlterieurProgramm= {
            date: null,
          };
          this.trx= null;
          this.currentPeriodiqueProgrammEnd= {
          date: null
        };
        this.currentTrancheProgramm= {
          date: null,
          amount: 0,
        };
        this.text_notification= "";
        this.step= 1;
      },
      closeProgrammTransaction(){
        this.resetProgrammTransaction();
        this.showPaiementDialog = false;
      },
      async saveProgramTransaction() {
        this.loadindScheduleTransaction = true;
        const data = {
          selected_type_programmation: this.selected_type_programmation,
          selected_tranches: this.selected_tranches,
          selected_canal: this.selected_canal,
          selected_periodicite: this.selected_periodicite,
          selected_ulterieur: this.currentUlterieurProgramm.date,
          selected_transaction: this.trx,
          date_debut_periodicite: this.currentPeriodiqueProgramm.date,
          date_fin_periodicite: this.currentPeriodiqueProgrammEnd.date,
          text_notification: this.text_notification
        }
  
        const response = await client({
          method: 'post',
          url: '/marchand/transaction/save_schedule',
          data: data
        })
            .then(resp => resp.data)
            .catch(error => {
              this.loadindScheduleTransaction = false;
              console.log(error)
              return {
                error: true
              }
            })
        this.loadindScheduleTransaction = false;
        if (!response.error) {
          this.resetProgrammTransaction();
          this.showPaiementDialog = false;
        }
        this.toast(response.type, response.message)
        this.getMarchandClientTransaction()
      },
      addTranche() {
        if (this.currentTrancheProgramm.date && this.currentTrancheProgramm.amount > 0 && (this.selected_tranches.filter(x => x.date === this.currentTrancheProgramm.date).length === 0)) {
          const {amount, date} = this.currentTrancheProgramm;
  
          this.selected_tranches.push({amount, date})
        }
      },
      getMeanName(item) {
        return item.mean._name + ' ' + item.mean._country._name + ' (' + item.mean._type + ')';
      },
      setDialog() {
  
      },
      transaactionItemAction(item, index) {
        switch (index) {
          // case 0:
          //   this.current_montant_total = item._amount
          //   this.trx = item
          //   this.showPaiementDialog = true;
          //   break;
           case 0:
            this.$router.push({name: 'intramScholar.transaction.details', params: {transaction_id: item._id}})
            break;
          // case 2:
          //   this.changeStatus({_status:true,_id:item._id})
          //   break;
          // case 3:
          //   this.changeStatus({_archive:true,_id:item._id})
          //   break;
          case 4:
            this.linkedClients = item._clients_transaction;
            this.linkedClientsDialog = true;
          break;
         
        }
      },
      initialize() {
        this.checkisDashboard();
        this.getMarchandClientTransaction()
        this.getMarchanProducts()
        this.getMarchandCustomers()
        this.getCategories()
      },
      checkisDashboard() {
        this.$emit('checkisDashboard', true);
      },
      async changeStatus(data) {
        const response = await client({
          method: 'post',
          url: 'marchand/transaction/status',
          data:data
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.toast(!response.error ? 'success' : 'error', response.message)
          this.getMarchandClientTransaction()
        }
      },
      async getMarchandCustomers() {
        const response = await client({
          method: 'get',
          url: 'marchand/marchand_customer/get/',
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.clients = response.marchandclients
        }
      },
      async getCategories() {
        const response = await client({
          method: 'get',
          url: '/client_category/get'
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error) {
          this.categories = response.categories
        }
      },
      async getMarchandClientTransaction(page=1) {
        this.loadingTransactions = true
        const response = await client({
          method: 'get',
          url: `/school-payments/transactions/school/${this.$route.params.school_id}?page=${page}&academicYearId=${this.$route.query.academic_year}`,
        //   data: {page:page}
        })
            .then(res => res.data)
            .catch(error => {
              console.log(error)
              this.loadingTransactions = false
              return {
                error: true
              }
            })
        this.loadingTransactions = false
        if (response && !response.error)
          this.transactions = response.transactions
          this.allTransaction=response.transactions;
           this.page=response.page+1;
           this.total_pages = response.total_pages
      }
    },
    computed: {
      text_selected_canal: function () {
        if (this.selected_canal === 'whatsapp')
          return 'les numéros whatsapp'
  
        if (this.selected_canal === 'sms')
          return 'les numéros de téléphone'
  
        if (this.selected_canal === 'email')
          return 'les adresses mails'
  
        return ''
      },
      title_action_type_programmation: function () {
        if (this.selected_type_programmation === 'tranche')
          return 'Configuration des tranches des paiements';
        else if (this.selected_type_programmation === 'periodique')
          return 'Configuration de la Périodicité de paiement';
        else if (this.selected_type_programmation === 'ulterieur')
          return 'Configuration de la date de paiement';
  
        return ''
      },
      headers: function () {
  
        return [
          {text: 'Statut', value: '_status'},
          {text: 'Nom', value: '_name'},
          {text: 'Montant', value: '_amount'},
          {text: 'Paiement par :', value: '_type_programmation'},
          {text: 'Date', value: '_createdAt'},
          {text: '', value: 'action'},
        ]
      }
    },
    created() {
      this.initialize()
    }
  }
  </script>
  
  <style scoped>
  .programm_text{
    font-weight: bold;
    color: #29B3A6;
  }
  </style>
  